const qwUserLabelRouter = [
    {
        path: '/qiwei/userLabel/index',
        name: 'QWUserLabelIndex',
        component: () => import('@/views/qiwei/userLabel/index.vue'),
        meta: { title: '客户标签', agentId: 1000197, isQiwei: true },
    },
    {
        path: '/qiwei/userDetail/index',
        name: 'QWUserDetailIndex',
        component: () => import('@/views/qiwei/userDetail/index.vue'),
        meta: { title: '客户详情', agentId: 1000197, isQiwei: true },
    },{
        path: '/qiwei/myGroup/index',
        name: 'QWMyGroupIndex',
        component: () => import('@/views/qiwei/myGroup/index.vue'),
        // meta: { title: '我的群发',noAuth: true },
        meta: { title: '我的群发', agentId: 1000203, isQiwei: true },
    },{
        path: '/qiwei/myGroup/lookIndex',
        name: 'QWMyGroupLookIndex',
        component: () => import('@/views/qiwei/myGroup/lookIndex.vue'),
        // meta: { title: '发送情况',noAuth: true },
        meta: { title: '发送情况', agentId: 1000203, isQiwei: true },
    },{
        path: '/qiwei/myGroup/addIndex',
        name: 'QWMyGroupAddIndex',
        component: () => import('@/views/qiwei/myGroup/addIndex.vue'),
        // meta: { title: '新建群发',noAuth: true },
        meta: { title: '新建群发', agentId: 1000203, isQiwei: true },
    },{
        path: '/qiwei/myGroup/preview',
        name: 'QWMyGroupPreview',
        component: () => import('@/views/qiwei/myGroup/preview.vue'),
        // meta: { title: '预览群发',noAuth: true },
        meta: { title: '预览群发', agentId: 1000203, isQiwei: true },
    },{
        path: '/qiwei/youMaTong/index',
        name: 'QWYouMaTongIndex',
        component: () => import('@/views/qiwei/youMaTong/index.vue'),
        // meta: { title: '邮码通',noAuth: true },
        meta: { title: '邮码通', agentId: 1000205, isQiwei: true },
    },{
        path: '/qiwei/youMaTong/details',
        name: 'QWYouMaTongDetails',
        component: () => import('@/views/qiwei/youMaTong/details.vue'),
        // meta: { title: '邮码通',noAuth: true },
        meta: { title: '邮码通', agentId: 1000205, isQiwei: true },
    },{
        path: '/qiwei/kuaiJieHuiFu/index',
        name: 'QWKuaiJieHuiFuIndex',
        component: () => import('@/views/qiwei/kuaiJieHuiFu/index.vue'),
        // meta: { title: '快捷回复',noAuth: true },
        meta: { title: '快捷回复', agentId: 1000197, isQiwei: true },
    },{
        path: '/qiwei/kuaiJieHuiFu/details',
        name: 'QWKuaiJieHuiFuDetails',
        component: () => import('@/views/qiwei/kuaiJieHuiFu/details.vue'),
        meta: { title: '快捷回复',noAuth: true },
        // meta: { title: '快捷回复', agentId: 1000197, isQiwei: true },
    },
]

export default qwUserLabelRouter;
